import { css } from 'emotion'
import { TEXT_COLOR_LIGHT } from '../../constants/styleConstants'

export const textColorLightStyles = css`
  color: ${TEXT_COLOR_LIGHT};
`
